/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetBlogListingById
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetBlogListingByIdQueryQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetBlogListingByIdQueryQuery>({ ...options, query: Operations.GetBlogListingByIdQueryDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetBlogListingById = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetBlogListingByIdQueryQuery, TypescriptOperationsGenerated.GetBlogListingByIdQueryQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetBlogListingByIdQueryDocument, options);
};
export type PageGetBlogListingByIdComp = React.FC<{data?: TypescriptOperationsGenerated.GetBlogListingByIdQueryQuery, error?: Apollo.ApolloError}>;
export const withPageGetBlogListingById = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetBlogListingByIdQueryQuery, TypescriptOperationsGenerated.GetBlogListingByIdQueryQueryVariables>) => (WrappedComponent:PageGetBlogListingByIdComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetBlogListingByIdQueryDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetBlogListingById = {
      getServerPage: getServerPageGetBlogListingById,
      withPage: withPageGetBlogListingById,
      usePage: useGetBlogListingById,
    }